module.exports = __webpack_public_path__ + "img/partner.10a14539.svg";